import React, { useEffect } from "react";
import { accountService } from "@/_services";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { PageLoader } from "@/_components";
import Cookies from "universal-cookie";
import Grid from "@mui/material/Grid";
import { userLoginSuccess } from "../_redux/actions/accountActions";

function Transfer({ history, location, userLoginSuccess }) {
  const cookies = new Cookies();
  const enrollmentCode = cookies.get("ceCode");
  document.title = "LifeSafer - My Account";

  useEffect(() => {
    if (enrollmentCode !== undefined && enrollmentCode.length > 11) {
      // console.log("Code: " + enrollmentCode);
      accountService
        .loginCE(enrollmentCode)
        .then((result) => {
          if (result.userId !== undefined) {
            userLoginSuccess();
            const { from } = location.state || {
              from: { pathname: "/documents" },
            };

            if (from.pathname === "/documents") {
              cookies.set('documentModal', true, { path: '/' });
            }

            history.push(from);
          } else {
            cookies.remove("ceCode");
            history.push("/account/login");
          }
        })
        .catch(() => {
          history.push("/account/login");
        });
    }
    history.push("/");
  }, []);

  return (
    <Grid
      container
      direction="row"
      justifyContent="center"
      style={{ marginTop: 50 }}
    >
      <PageLoader />
    </Grid>
  );
}

Transfer.propTypes = {
  history: PropTypes.object,
  location: PropTypes.object.isRequired,
  userLoginSuccess: PropTypes.func,
};

function mapStateToProps(state) {
  return {
    userLoginSuccess: state.userLoginSuccess,
  };
}

const mapDispatchToProps = {
  userLoginSuccess,
};

export default connect(mapStateToProps, mapDispatchToProps)(Transfer);
